import { takeLatest } from "redux-saga/effects";

import chatActionCreators from "../../actions/chat";
import sagasUtils from "../../../utils/sagas.utils";

export function* watchSyncCompanyRooms() {
  yield takeLatest(chatActionCreators.syncCompanyRooms.toString(), sagasUtils.syncChatRooms);
}
